module.exports = __webpack_public_path__ + "assets/img/right_item04.503a9b9d.png";